module.exports = __webpack_public_path__ + "5a4683be7849d0dbe5c7f0683664873f.svg";